import React, { useEffect, useState } from 'react';
import { AppFooter } from './AppFooter';
import api from '../../api/client';

const JSSW_LOGO = "https://customer-assets.emergentagent.com/job_jina-users/artifacts/bk4divlg_Company%20Logo.png";

export function AuthLayout({ children }) {
  const [companyLogo, setCompanyLogo] = useState(JSSW_LOGO);

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await api.get('/settings/logo');
        if (response.data?.success && response.data?.data?.logo_url) {
          setCompanyLogo(response.data.data.logo_url);
        }
      } catch (err) {
        // Use default JSSW logo
      }
    };
    fetchLogo();
  }, []);

  return (
    <div className="min-h-screen flex flex-col relative auth-gradient-bg overflow-hidden">
      {/* Subtle grid texture */}
      <div className="grid-overlay" />

      {/* Top-left brand mark */}
      <div className="absolute top-6 left-6 z-10 flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl flex items-center justify-center"
             style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-default)', boxShadow: 'var(--shadow-card)' }}>
          <img src={companyLogo} alt="JSSW" className="h-7 w-auto" data-testid="auth-company-logo" />
        </div>
        <div className="hidden sm:flex flex-col leading-tight">
          <span className="text-[13px] font-heading font-semibold tracking-tight"
                style={{ color: 'var(--text-primary)' }}>
            Jina Special Steel
          </span>
          <span className="text-[11px] tracking-wider uppercase"
                style={{ color: 'var(--accent-primary)', letterSpacing: '0.14em' }}>
            Management System
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center p-4 relative z-10">
        {children}
      </div>

      {/* Footer */}
      <AppFooter isLoginPage />
    </div>
  );
}

export default AuthLayout;
